import applyBrandPrimaryColor from 'shared/helpers/brandThemeHelper';

const applyTheme = () => {
  const color = window?.globalConfig?.BRAND_PRIMARY_COLOR;
  if (color) {
    applyBrandPrimaryColor(color);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyTheme);
} else {
  applyTheme();
}
